import { FC } from 'react';

import classNames from 'classnames';

import styles from './hint.module.scss';

type HintMode = 'warning' | 'danger';

interface IHintProps {
  mode?: HintMode;
}

const Hint: FC<IHintProps> = props => {
  const { children, mode = 'danger' } = props;

  const hintClassNames = classNames(styles.hint, {
    [styles[`${mode}`]]: mode,
  });

  return <div className={hintClassNames}>{children}</div>;
};

export { Hint };
